'use client'

import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react'
import { Toaster as Sonner, type ToasterProps } from 'sonner'
import { useTheme } from '../../lib/theme'

/**
 * Shadcn's toaster, without its theme hook.
 *
 * The registry's version reads `next-themes`. The console already owns its theme choice in
 * `src/lib/theme.ts` (light, dark or system, the same three the public website offers), so a
 * second library holding a second copy of that answer is one to drop.
 *
 * Mounted exactly once, in `main.tsx`. A second one inside a screen would add another
 * `role="status"` region to that screen's test tree, where the singular role queries live.
 */
const Toaster = ({ ...props }: ToasterProps) => {
	const { resolved } = useTheme()
	return (
		<Sonner
			theme={resolved}
			className="toaster group"
			icons={{
				success: <CircleCheckIcon className="size-4" />,
				info: <InfoIcon className="size-4" />,
				warning: <TriangleAlertIcon className="size-4" />,
				error: <OctagonXIcon className="size-4" />,
				loading: <Loader2Icon className="size-4 animate-spin" />,
			}}
			style={
				{
					'--normal-bg': 'var(--popover)',
					'--normal-text': 'var(--popover-foreground)',
					'--normal-border': 'var(--border)',
					'--border-radius': 'var(--radius)',
				} as React.CSSProperties
			}
			toastOptions={{
				classNames: {
					toast: 'cn-toast',
				},
			}}
			{...props}
		/>
	)
}

export { Toaster }
